import currency from 'currency.js';

const currencyOptions = { symbol: 'S/ ' };
export const currencyFormat = (value) => currency(value, currencyOptions).format();
export const currencyGetValue = (value) => currency(value, currencyOptions).value;
export const amountValidRegex = /^[0-9]*\.?[0-9]*$/;